module.exports = __webpack_public_path__ + "img/classic-75.b03a40ff.png";